import { Component, input } from '@angular/core';
import { IconNames } from '@shared/enums/icon-names';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-ice-back-button',
  templateUrl: './ice-back-button.component.html',
  styleUrls: ['./ice-back-button.component.scss'],
  imports: [MatIcon],
})
export class IceBackButtonComponent {
  IconNames = IconNames;

  testId = input.required<string>();
}
